import { render, staticRenderFns } from "./OrganisationSwitch.vue?vue&type=template&id=39c02efd&scoped=true"
import script from "./OrganisationSwitch.vue?vue&type=script&lang=js"
export * from "./OrganisationSwitch.vue?vue&type=script&lang=js"
import style0 from "./OrganisationSwitch.vue?vue&type=style&index=0&id=39c02efd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c02efd",
  null
  
)

export default component.exports